export const actions = [
    {
        option: {
            value: 'open_link',
            label: 'Open Url',
        },
        valueBuilder: (url) => ({
            id: 'open_link',
            action_type: "U",
            params: {url},
            url,
        }),
    },
    {
        option: {
            value: 'close_notif',
            label: 'Close Message',
        },
        valueBuilder: (url) => ({
            id: 'close_notif',
            action_type: "D",
            params: {}
        }),
    },
    {
        option: {
            value: 'open_site',
            label: 'Open My Site',
        },
        valueBuilder: (url) => ({
            id: 'open_site',
            action_type: "U",
            params: {url},
            url
        }),
    }
];

export const dialogPositions = [
    {
        value: 'top-center', label: 'top-center'
    }, {
        value: 'top-left', label: 'top-left',
    }, {
        value: 'top-center', label: 'top-center'
    }, {
        value: 'top-right', label: 'top-right'
    }, {
        value: 'bottom-left', label: 'bottom-left'
    }, {
        value: 'bottom-center', label: 'bottom-center'
    }, {
        value: 'bottom-right', label: 'bottom-right'
    }
];

export const dialogMobilePositions = [
    {
        value: 'top', label: 'top'
    }, {
        value: 'bottom', label: 'bottom'
    }
];

export const dialogDirections = [
    {
        'value': 'ltr',
        'label': 'Left to right'
    },    {
        'value': 'rtl',
        'label': 'Right to left'
    }
];

export const SETTING_SAVE_TYPES = {
    GENERAL: "bestpush_save_general", // for both Activate & General tabs
    PROMPT: "bestpush_save_prompt",
    BELL: "bestpush_save_bell",
}